<template>
  <div v-bg-image="'images/josefin-WS5yjFjycNY-unsplash-lightgreen.jpg'" class="grid grid-cols-5 text-sm text-white bg-cover 2xl:grid-cols-4">
    <div class="relative col-span-3 2xl:col-span-3">
      <div class="absolute inset-0 disclaimer">
        <img src="images/BIRD_EYE_VIEW_FINAL.jpg" srcset="images/BIRD_EYE_VIEW_FINAL.jpg 1440w, images/BIRD_EYE_VIEW_FINAL@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full">
      </div>
    </div>
    <div class="flex flex-col col-span-2 px-12 py-20 pb-4 xl:px-16 xl:py-24 2xl:col-span-1">
      <h1 class="mb-8 text-3xl font-bold uppercase xl:mb-32">
        Project Information
      </h1>

      <swiper :space-between="100" pagination loop :autoplay="{ delay: 30000 }" class="flex-1 leading-normal w-full">
        <swiper-slide class="">
          <div class="grid grid-cols-1 xl:grid-cols-2 table-info">
            <span class="font-bold">ชื่อโครงการ</span>
            <span>เอสเซ็นท์ ระยอง 2<br>ESCENT RATONG II</span>

            <span class="font-bold">เจ้าของโครงการ</span>
            <span>บริษัท ซีพีเอ็น เรซซิเด้นซ์ จํากัด</span>

            <span class="font-bold">ที่ตั้งโครงการ</span>
            <span>ตําบลเชิงเนิน อําเภอเมือง จังหวัดระยอง 21000</span>

            <span class="font-bold">พื้นที่โครงการ</span>
            <span>ประมาณ 2 – 1 – 69.5 ไร่</span>

            <span class="font-bold">ลักษณะโครงการ</span>
            <ul>
              <li>
                High-rise สูง 23 ชั้น 1 อาคาร
              </li>
              <li>
                ห้องพัก 420 ยูนิต และ ร้านค้า 1 ยูนิต
              </li>
              <li>
                รวม 421 ยูนิต อาคารจอดรถ 3 ชั้น
              </li>
            </ul>

            <span class="font-bold">ที่จอดรถ</span>
            <ul>
              <li>
                ประมาณ 138 ช่องจอด
              </li>
              <li>
                คิดเป็น 32% (ไม่รวมซ้อนคัน)
              </li>
            </ul>
          </div>
        </swiper-slide>

        <swiper-slide class="space-y-4">
          <div class="font-bold">
            รายละเอียดห้องชุด
          </div>
          <div>
            <div class="flex justify-between font-bold">
              <span>ประเภทห้อง</span>
              <span>พื้นที่ใช้สอยประมาณ</span>
            </div>
            <div class="flex justify-between">
              <span>1 Bedroom 1 Bathroom</span>
              <span>28 - 29 ตร.ม.</span>
            </div>
            <div class="flex justify-between">
              <span>1 Bedroom 1 Bathroom</span>
              <span>32 - 33 ตร.ม.</span>
            </div>
            <div class="flex justify-between">
              <span>2 Bedrooms 2 Bathrooms</span>
              <span>51 - 68 ตร.ม.</span>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="space-y-2 xl:space-y-4">
          <h2 class="font-bold">
            สิ่งอํานวยความสะดวก
          </h2>
          <ul class="mx-4 list-disc">
            <li>
              Rooftop Pool ขนาด 25x5m ระบบน้ำเกลือ แยกโซน เด็กผู้ใหญ่ และจากุชชี่
            </li>
            <li>
              Fitness ลอยฟ้า ชั้น 23 พร้อมด้วยซาวน่า
            </li>
            <li>
              Co Living Space ชั้น 23 สำหรับทำกิจกรรม
            </li>
            <li>
              สวนลอยฟ้าแยกสัดส่วนการใช้งาน ทั้ง Active Zone สร้างกิจกรรมดีๆ ด้วย Outdoor Theater
            </li>
            <li>
              และ Passive Zone ให้ความสงบ เหมาะกับการพักผ่อน
            </li>
            <li>
              Multi Purpose Room บริเวณชั้น 1
            </li>
            <li>
              Laundry Cafe’ พื้นที่พักผ่อนระหว่างรอซักผ้า
            </li>
            <li>
              Jogging Track บริเวณด้านข้างอาคาร ชั้น 1
            </li>
          </ul>

          <h2 class="font-bold">
            ระบบรักษาความปลอดภัย
          </h2>
          <ul class="mx-4 list-disc">
            <li>
              Access Control เพิ่มความปลอดภัยเข้าออกโครงการ และส่วนกลาง
            </li>
            <li>
              Face Scan ครอบคลุมพื้นที่เข้าออกโครงการ
            </li>
            <li>
              Pass Card สำหรับรถยนต์ตั้งแต่ทางเข้าด้านหน้า
            </li>
            <li>
              CCTV  และระบบรักษาความปลอดภัย Security Guards ตลอด 24 ชั่วโมง
            </li>
            <li>
              VMS ระบบนัดหมายเข้าพบลูกบ้านให้คุณมั่นใจได้ถึงความปลอดภัยสูงสุด
            </li>
          </ul>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'ProjectDetails',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>

<style lang="postcss" scoped>
.table-info {
  & > *:nth-child(even) {
    @apply mb-2;
  }

  & > *:last-child {
    @apply mb-0;
  }
}

@screen xl {
  .table-info {
    grid-template-columns: minmax(112px, 1fr) auto;

    & > *:nth-child(even) {
      @apply mb-0;
    }
  }
}
</style>
